export const NoMatch = () => {
    return (
        <>
            <div className="h3">Error Code: 404. We can't seem to find the page you're looking for.</div>
        </>
    );
};
